import { render, staticRenderFns } from "./IndexOffline.vue?vue&type=template&id=0207b50b&"
import script from "./IndexOffline.vue?vue&type=script&lang=js&"
export * from "./IndexOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports